import { getClassFunction } from '@helpers/functions';

const getClass = getClassFunction('kf-o-top-bar');

const openSitePreferenceEvent = 'open-site-preferences';

class TopBar {
  topBar: HTMLDivElement;

  constructor(topBar: HTMLDivElement) {
    this.topBar = topBar;

    this.addEventToSiteButton();
  }

  get isTopBarAvailable() {
    const styles = window.getComputedStyle(this.topBar);

    return styles.display !== 'none';
  }

  addEventToSiteButton() {
    const siteButton = this.topBar.querySelector<HTMLButtonElement>(getClass('sites'));
    const languageButton = this.topBar.querySelector<HTMLButtonElement>(getClass('languages'));

    this.addOpenSitePreferencesEvent(siteButton);
    this.addOpenSitePreferencesEvent(languageButton);
  }

  handleKeyEventToOpenSitePreferences(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onOpenSitePreferences();
    }
  }

  addOpenSitePreferencesEvent(button?: HTMLButtonElement | null) {
    button?.addEventListener('click', this.onOpenSitePreferences.bind(this));
    button?.addEventListener('keydown', (event) => this.handleKeyEventToOpenSitePreferences(event));
  }

  onOpenSitePreferences() {
    if (!this.isTopBarAvailable) return;

    window.dispatchEvent(new CustomEvent(openSitePreferenceEvent));
  }
}

export { TopBar, openSitePreferenceEvent };
